import { BaseModel } from '@core/data-access';
import { Default } from '@core/util';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { Exclude, Expose, Type } from 'class-transformer';

@Exclude()
export class BankStatementModel extends BaseModel {
  @Expose()
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  files!: UploadFileControl;
}
